import { Box, Container } from "@mui/material";
import { Button } from "@chemaxon/design-system/button";
import { Checkbox } from "@chemaxon/design-system/checkbox";
import { FormControlLabel } from "@chemaxon/design-system/form";
import React, { useState } from "react";
import FormActions from "@chemaxon/terminus-client/ui/components/form/FormActions";
import EusaContent from "./EusaContent";
import Paper from "@mui/material/Paper";
import { useAcceptEusa } from "@chemaxon/terminus-client/ui/services/TeamMemberService";
import { useGetCurrentUser } from "@chemaxon/terminus-client/ui/services/UserInfoService";
import log from "loglevel";
import FormLayoutVertical from "@chemaxon/terminus-client/ui/components/form/FormLayoutVertical";
import { Background } from "@chemaxon/design-system/color";

const Eusa = () => {
  const [hasRead, setHasRead] = useState(false);

  const getCurrentUserQueryResult = useGetCurrentUser();
  const mutateAcceptEusa = useAcceptEusa();

  const user = getCurrentUserQueryResult.data;

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = event => {
    event.preventDefault();

    if (!user) {
      log.error("User is not defined.");
      return;
    }

    mutateAcceptEusa.mutateAsync(user.id).catch(err => {
      log.error("Failed to upload the custom EUSA file.", err);
    });
  };

  return (
    <Box
      sx={{
        backgroundColor: Background.main,
        height: "100%",
        width: "100%",
      }}
    >
      <Container
        maxWidth={"lg"}
        sx={{
          height: "100%",
        }}
      >
        <Box
          sx={{
            height: "100%",
            boxSizing: "border-box",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            fontFamily: "'Roboto', sans-serif",
            justifyContent: "center",
          }}
        >
          <Paper elevation={3}>
            <EusaContent />
            <form id="eusaForm" onSubmit={handleSubmit}>
              <FormLayoutVertical
                justifyContent={"center"}
                alignItems={"center"}
                my={6}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      name={"ném"}
                      onChange={e => setHasRead(e.target.checked)}
                    />
                  }
                  label={"I have read the subscription terms"}
                />
                <FormActions>
                  <Button
                    disabled={!hasRead}
                    colorVariant="primary"
                    type="submit"
                    loading={mutateAcceptEusa.isPending}
                  >
                    Accept
                  </Button>
                </FormActions>
              </FormLayoutVertical>
            </form>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
};

export default Eusa;
